import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAuthenticationStatus } from "../app/features/global/globalSlice";
import CreateBlog from "../components/CreateBlog";
import PageNotFound from "./PageNotFound";

function CreateBlogPage(){
    let dispatch = useDispatch();
    let baseUrl = useSelector(state=>state.global.value.baseUrl);
    let isAuthenticated = useSelector(state=>state.global.value.isAuthenticated);

    useEffect(()=>{

    }, [])

    return(
        <div className="createBlogPage">
            {
                isAuthenticated==undefined ? 
                <PageNotFound /> :
                isAuthenticated ?
                <CreateBlog /> :
                <PageNotFound />
            }
        </div>
    )
}

export default CreateBlogPage;